export default class ClubInvoicePayment {
    static CONTEXT_DEFAULT = 'default';
    static CONTEXT_SEPA_DIRECT_DEBIT_EXPORT = 'sepaDirectDebitExport';
    static CONTEXT_SEPA_CREDIT_TRANSFER_EXPORT = 'sepaCreditTransferExport';
    static CONTEXT_CHARGEBACK = 'chargeback';
    static CONTEXT_CHARGEBACK_FEE = 'chargebackFee';
    static CONTEXT_FINLEAP_CONNECT = 'finleapConnect';

    static fromData(data) {
        if (!data) {
            return;
        }
        const clubInvoicePayment = new ClubInvoicePayment();
        clubInvoicePayment.id = data.id;
        clubInvoicePayment.currency = data.currency;
        clubInvoicePayment.appliedAt = data.appliedAt;
        clubInvoicePayment.money = {
            numerator: data.money.data.numerator,
            denominator: data.money.data.denominator,
        };
        clubInvoicePayment.formattedMoney = data.formattedMoney;
        clubInvoicePayment.isDunningFee = data.isDunningFee;
        clubInvoicePayment.note = data.note;
        clubInvoicePayment.context = data.context;

        Object.seal(clubInvoicePayment);
        return clubInvoicePayment;
    }

    isChargeback() {
        return this.context === ClubInvoicePayment.CONTEXT_CHARGEBACK;
    }

    isChargebackFee() {
        return this.context === ClubInvoicePayment.CONTEXT_CHARGEBACK_FEE;
    }
}
